import React from "react";

// Styles //
import "./checkbox-filter-enctal.scss";

interface CheckboxFilterProps {
    id: string;
    label: string;
    name: string;
    value: string;
    handleChange?: (e: any) => void;
}

const CheckboxFilterEnctal = (props: CheckboxFilterProps) => {
    const { id, label, name, value, handleChange } = props;

    return (
        <div className="wrapper-filter-enctal">
            <div className={`checkbox-filter-enctal`}>
                <input
                    type="checkbox"
                    name={name}
                    id={id}
                    value={value}
                    data-label={label}
                    onChange={handleChange}
                />
                <label htmlFor={id}>
                    {label}
                </label>
            </div>
        </div>
    );
};

export default CheckboxFilterEnctal;
